import { createSelector } from '@ngrx/store';

import { TrackingEntity } from '../reducers/basket-tracking.reducer';

import { selectBasketTrackingState } from './feature.selectors';

export const selectAllBasketItemsTracking = createSelector(
  selectBasketTrackingState,
  (state) => {
    return Object.values(state.entities) as TrackingEntity[];
  },
);
